import {useState} from 'react'

const InformationLayout = () => {
  const [show, setShow] = useState(true)

  const handleClose = () => {
    setShow(false)
  }

  return (
    <div>
      {show && (
        <div
          style={{
            borderRadius: '20px',
            background: 'linear-gradient(90deg, #F95E2F 0%, #FFD7A3 100%)',
          }}
          className='mt-10'
        >
          <div className='d-flex justify-content-between'>
            <div className='text-white p-10 fw-normal'>
              <p className='display-6 fw-normal'>Panduan</p>
              <p className='mb-5'>
                Langkah-langkah mudah untuk mengisi formulir penilaian dengan benar.
              </p>
            </div>
            <div className='p-5' style={{cursor: 'pointer'}} onClick={handleClose}>
              <i className='fa fa-close text-black'></i>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default InformationLayout
